export default {
  ATTACHMENT: "BY",
  ATTACHMENT_TYPE: "BYLSRT",
  FILE_NAME: "FILNM",
  FILE_DATA: "DATA",
  FILE_EXTENSION: "EXT",
};
